import { render, staticRenderFns } from "./DepartmentCourses.vue?vue&type=template&id=31ba7446"
import script from "./DepartmentCourses.vue?vue&type=script&lang=js"
export * from "./DepartmentCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports